// extracted by mini-css-extract-plugin
module.exports = {"WarhammerImage":"WarhammerImage_WarhammerImage__1bCVx","imageWrapper":"WarhammerImage_imageWrapper__3Moz2"};